import useId from '../utils/useId';
import * as React from 'react';
export const monzoSvg = React.forwardRef(function monzoSvgInner(props, ref) {
  const id_0 = useId();
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#151E2B',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement(
      'g',
      {
        clipPath: `url(#bi_monzo__a_${id_0})`,
      },
      /*#__PURE__*/ React.createElement('path', {
        d: 'M25.866 19.974a.915.915 0 0 1-.268.646l-4.096 4.096a.366.366 0 0 1-.624-.259V15.28l4.931-4.903h.057v9.598Z',
        fill: '#EC553D',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'M22.598 7.107a.366.366 0 0 0-.518 0l-6.09 6.09h-.085v6.875l.085.18 4.888-4.888 4.988-4.988-3.268-3.269Z',
        fill: '#BBF125',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'M6.113 19.974c0 .242.097.475.268.646l4.096 4.096c.23.23.625.067.625-.259V15.28L6.17 10.377h-.057v9.598Z',
        fill: '#317A9C',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'M9.9 7.107a.366.366 0 0 0-.518 0l-3.269 3.269 4.989 4.988 4.888 4.888v-7.054L9.9 7.107Z',
        fill: '#61C9A8',
      }),
    ),
    /*#__PURE__*/ React.createElement(
      'defs',
      null,
      /*#__PURE__*/ React.createElement(
        'clipPath',
        {
          id: `bi_monzo__a_${id_0}`,
        },
        /*#__PURE__*/ React.createElement('path', {
          fill: '#fff',
          transform: 'translate(6 7)',
          d: 'M0 0h19.98v17.953H0z',
        }),
      ),
    ),
  );
});
monzoSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var monzo = {
  category: 'brand',
  colorable: false,
  name: 'monzo',
  svg: monzoSvg,
};
